<template>
  <footer
    role="contentinfo"
    id="piv_piedPage"
  >
    <div class="footerSite">
    </div>
    <div class="piv_bas">
      <div class="contenu contenu-fixe">
        <div id="logo">
          <a href="https://quebec.ca"><img
              id="logoFooter"
              alt="Gouvernement du Québec."
              src="https://portail.csqc.ca/portail/images/quebec_couleur.svg"
              width="117"
              height="35"
            /></a>
        </div>
        <div id="credits">
          <small><a
              href="http://www.droitauteur.gouv.qc.ca/copyright.php"
              target="_blank"
            >© Gouvernement du Québec, {{anneeEnCours}}</a></small>
        </div>
      </div>
    </div>
  </footer>

</template>

<script>
export default {
  data: () => ({
  }),
  computed: {
    anneeEnCours() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style lang="css" scoped>

</style>
